import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ReferenceProps } from "@services/api/reference/reference.types";
import useReference from "./reference.hook";

type Result = {
  references: ReferenceProps[];
};

export function useReferences(
  type?: string,
  yearExternalId?: string,
  visible?: boolean
): Result {
  const { getActiveReferences } = useReference();

  const { data: activeReferences } = useQuery({
    queryKey: [type, yearExternalId],
    queryFn: async () => await getActiveReferences(type, yearExternalId)
  });

  const [references, setReferences] = useState<ReferenceProps[]>([]);
  useEffect(() => {
    if (!activeReferences) return;

    const filteredReferences = activeReferences.filter(
      (reference: ReferenceProps) =>
        visible ? reference.visible === visible : true
    );
    setReferences(filteredReferences);
  }, [activeReferences, visible]);

  return { references };
}
